
    <div class="container" fxLayout="column" fxLayoutGap="16px">
      <div class="mat-title">
        {{ (disable ? 'location' : 'location-title') | translate | titlecase }}
      </div>
      <div class="mat-subheading-2" *ngIf="!disable">
        {{ 'location-description' | translate }}
      </div>

      <div fxLayout="column" fxLayout.sm="row" fxLayoutGap.sm="16px">
        <mat-form-field class="full-width">
          <mat-label>{{ 'name' | translate | titlecase }}</mat-label>
          <input matInput [formControl]="inputForm" />
          <mat-error *ngIf="inputForm.hasError('required')">
            {{ 'name' | translate | titlecase }} {{ 'is-required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{ 'search' | translate | titlecase }}</mat-label>
          <input
            [disabled]="disable"
            matInput
            (keydown.enter)="$event.preventDefault()"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            type="text"
            #search
          />
        </mat-form-field>
      </div>
      <agm-map
        [latitude]="startLatitude"
        [longitude]="startLongitude"
        [zoomControl]="true"
        [mapDraggable]="true"
        [disableDefaultUI]="true"
        [zoom]="START_ZOOM"
        [mapTypeId]="'hybrid'"
        #agmMap
        (mapReady)="onMapReady($event)"
      >
      </agm-map>

      <div
        *ngIf="oneTimeToggle"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
      >
        <mat-slide-toggle
          [formControl]="oneTimeLocationControl"
        ></mat-slide-toggle>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          class="info-locations"
        >
          <div>
            <mat-icon svgIcon="info"></mat-icon>
          </div>
          <div>
            <b>{{ 'notice' | translate }}:</b>
            {{ 'info-toggle-location' | translate }}
          </div>
        </div>
      </div>

      <ml-customer-location-pin
        [pins]="pins"
        [disable]="disable"
        (primary)="onPrimaryPin($event)"
        (remove)="onRemovePin($event)"
      ></ml-customer-location-pin>

      <div fxLayout="row" fxLayoutAlign="flex-end center">
        <button mat-button (click)="onCancel()">
          {{ 'cancel' | translate | uppercase }}
        </button>
        <button *ngIf="!disable" mat-button (click)="onClear()">
          {{ 'clear' | translate | uppercase }}
        </button>
        <button
          *ngIf="!disable"
          mat-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!valid"
        >
          {{ 'submit' | translate | uppercase }}
        </button>
      </div>
    </div>
  